(function () {
  var STORAGE_PREFIX = "baci-scroll-position:";
  // BACI CUSTOM START: collection scroll restoration
  var COLLECTION_RESTORE_PREFIX = "baci-collection-restore:";
  var COLLECTION_RESTORE_TTL = 30 * 60 * 1000;
  // BACI CUSTOM END: collection scroll restoration
  var MAX_RESTORE_ATTEMPTS = 120;
  var RESTORE_RETRY_DELAY = 50;
  var RESTORE_TOLERANCE = 2;
  var STABLE_RESTORE_ATTEMPTS = 3;

  if (!window || !document) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var storage;
  try {
    storage = window.sessionStorage;
  } catch (error) {
    return;
  }

  if (!storage) return;

  try {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  } catch (error) {
    // Some embedded browsers expose history but reject assignment.
  }

  var restoreTimer = null;
  var restoreTarget = null;
  var restoreAttempts = 0;
  var stableRestoreAttempts = 0;

  function getStorageKey() {
    return STORAGE_PREFIX + window.location.pathname + window.location.search;
  }

  function isBackForwardNavigation(event) {
    var navigationEntries;

    if (event && event.persisted) return true;

    try {
      if (window.performance && typeof window.performance.getEntriesByType === "function") {
        navigationEntries = window.performance.getEntriesByType("navigation");
        if (navigationEntries && navigationEntries[0]) {
          return navigationEntries[0].type === "back_forward";
        }
      }

      if (window.performance && window.performance.navigation) {
        return window.performance.navigation.type === 2;
      }
    } catch (error) {
      return false;
    }

    return false;
  }

  // BACI CUSTOM START: collection scroll restoration
  function getCollectionRestoreKey() {
    return COLLECTION_RESTORE_PREFIX + window.location.pathname + window.location.search;
  }

  function clearCollectionRestoreState() {
    try {
      storage.removeItem(getCollectionRestoreKey());
    } catch (error) {
      // Ignore blocked storage and let the collection script handle the page.
    }
  }

  function hasCollectionRestoreState() {
    var rawState;
    var state;

    try {
      rawState = storage.getItem(getCollectionRestoreKey());
      if (!rawState) return false;

      state = JSON.parse(rawState);
      if (
        !state ||
        state.collectionKey !== window.location.pathname + window.location.search ||
        !state.timestamp ||
        Date.now() - state.timestamp > COLLECTION_RESTORE_TTL
      ) {
        clearCollectionRestoreState();
        return false;
      }

      return true;
    } catch (error) {
      clearCollectionRestoreState();
      return false;
    }
  }

  function isCollectionPage() {
    return Boolean(
      document.querySelector('[data-section-type="collection"]') &&
      document.querySelector(".collection__infinite-container")
    );
  }

  function shouldDeferToCollectionRestore() {
    return isCollectionPage() && hasCollectionRestoreState();
  }
  // BACI CUSTOM END: collection scroll restoration

  function getPageHeight() {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(
      body ? body.scrollHeight : 0,
      html ? html.scrollHeight : 0
    );
  }

  function getScrollX() {
    return window.pageXOffset || document.documentElement.scrollLeft || (document.body && document.body.scrollLeft) || 0;
  }

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || (document.body && document.body.scrollTop) || 0;
  }

  function sanitizePosition(position) {
    if (!position || typeof position !== "object") return null;

    var x = Number(position.x);
    var y = Number(position.y);

    if (!isFinite(x) || !isFinite(y)) return null;

    return {
      x: Math.max(0, Math.round(x)),
      y: Math.max(0, Math.round(y))
    };
  }

  function readPosition() {
    try {
      return sanitizePosition(JSON.parse(storage.getItem(getStorageKey())));
    } catch (error) {
      return null;
    }
  }

  function savePosition() {
    try {
      storage.setItem(
        getStorageKey(),
        JSON.stringify({
          x: getScrollX(),
          y: getScrollY()
        })
      );
    } catch (error) {
      // Storage can be full or blocked. Native scrolling remains unchanged.
    }
  }

  function isAtRestoreTarget() {
    return restoreTarget &&
      Math.abs(getScrollX() - restoreTarget.x) <= RESTORE_TOLERANCE &&
      Math.abs(getScrollY() - restoreTarget.y) <= RESTORE_TOLERANCE;
  }

  function finishRestore() {
    restoreTarget = null;
    restoreAttempts = 0;
    stableRestoreAttempts = 0;
  }

  function scheduleRestoreAttempt() {
    restoreTimer = window.setTimeout(tryRestorePosition, RESTORE_RETRY_DELAY);
  }

  function tryRestorePosition() {
    if (!restoreTarget) return;

    var maxScrollableY = Math.max(0, getPageHeight() - window.innerHeight);
    var canReachSavedPosition = maxScrollableY >= restoreTarget.y;
    var outOfRetries = restoreAttempts >= MAX_RESTORE_ATTEMPTS;

    if (canReachSavedPosition || outOfRetries) {
      window.scrollTo(restoreTarget.x, restoreTarget.y);

      if (isAtRestoreTarget() || outOfRetries) {
        stableRestoreAttempts += 1;
      } else {
        stableRestoreAttempts = 0;
      }

      if (stableRestoreAttempts >= STABLE_RESTORE_ATTEMPTS || outOfRetries) {
        finishRestore();
        return;
      }
    } else {
      stableRestoreAttempts = 0;
    }

    restoreAttempts += 1;
    scheduleRestoreAttempt();
  }

  function restorePosition(event) {
    if (window.location.hash) return;
    if (!isBackForwardNavigation(event)) return;

    // BACI CUSTOM START: collection scroll restoration
    if (shouldDeferToCollectionRestore()) {
      if (restoreTimer) {
        window.clearTimeout(restoreTimer);
      }

      finishRestore();
      return;
    }
    // BACI CUSTOM END: collection scroll restoration

    var position = readPosition();
    if (!position) return;

    if (restoreTimer) {
      window.clearTimeout(restoreTimer);
    }

    restoreTarget = position;
    restoreAttempts = 0;
    stableRestoreAttempts = 0;
    tryRestorePosition();
  }

  function shouldSaveLinkClick(event) {
    var link = event.target && event.target.closest
      ? event.target.closest("a[href]")
      : null;

    if (!link) return false;

    var href = link.getAttribute("href");
    if (!href || href.charAt(0) === "#" || href.indexOf("javascript:") === 0) {
      return false;
    }

    return true;
  }

  window.addEventListener("pagehide", savePosition);
  window.addEventListener("beforeunload", savePosition);
  window.addEventListener("pageshow", restorePosition);
  window.addEventListener("load", restorePosition);

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
      savePosition();
    }
  });

  document.addEventListener("click", function (event) {
    if (shouldSaveLinkClick(event)) {
      savePosition();
    }
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", restorePosition);
  } else {
    restorePosition();
  }
})();